<template>
    <div class="offers-claimed-chart">
        <div class="heading">
            <h4 class="heading__h4 text-white left">Offers Claimed</h4>
            <div class="right">
                <select @change="onChange($event)" name="lstYears" class="form-select fs-3 shadow border-0 p-3 pe-5 rounded-10 bg-orange bg-opacity-25 text-white" id="lstYears">

                    <option :selected="(index==0) ? 'selected' : false" v-for="(year, index) in yearsList" :key="year"> {{year}} </option>

                </select>
            </div>
        </div>
        <!-- <canvas id="offerChart"></canvas> -->
<!--        :chartData="data"-->
        <line-chart
            :data="data"
            :options="options"

        ></line-chart>
    </div>
</template>

<script>
import LineChart from './LineChart.vue'
export default {
    components: { LineChart },
    name: 'OffersClaimedChartComponent',
    data() {
        return{
            data: {},
            yearsList: [new Date().getFullYear(), new Date().getFullYear() - 1, new Date().getFullYear() - 2, new Date().getFullYear() - 3, new Date().getFullYear() - 4],
            options: {
                maintainAspectRatio: false,
                legend: {
                    position: "bottom",
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            fontColor: "rgba(255,255,255,1)",
                            fontStyle: "normal",
                            beginAtZero: true,
                            maxTicksLimit: 5,
                            padding: 10
                        },
                        gridLines: {
                            color: "rgba(210,217,224,0.5)",
                            zeroLineColor: "rgba(210,217,224,0.5)"
                        }

                    }],
                    xAxes: [{
                        gridLines: {
                            display: false
                        },
                        ticks: {
                            padding: 10,
                            fontColor: "rgba(255,255,255,1)",
                            fontStyle: "normal"
                        }
                    }]
                }
            },
        }
    },

    methods: {
        onChange(event) {
           if(event.target.value) {
               this.getChartData({'period': event.target.value})
           }
        },
        getChartData(payload) {
            axios.get(this.apiEndPoints.getChartData, {params:payload})
                .then((response) => {
                    // console.log(response);
                    if(response.data && response.data.length) {
                     this.data = response.data;
                    }


                })
                .catch((error) => {
                    // console.error(error, 'here');
                    // console.error(error.status,'here')

                    if (error.response.status == 401 || error.response.status == 419) {
                        this.$router.push({name : 'sign_in'});
                    }
                }).finally(() => {

            });
        }
    },
    mounted() {
        this.getChartData({'period': new Date().getFullYear()});
        /* var ctx = document.getElementById('offerChart').getContext("2d");

        var myChart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug","Sep","Oct","Nov","Dec"],
                datasets: [{
                    label: "Data",
                    borderColor: "#FFFFFF",
                    pointBorderColor: "#0069aa",
                    pointBackgroundColor: "#FFFFFF",
                    pointHoverBackgroundColor: "#0069aa",
                    pointHoverBorderColor: "#FFFFFF",
                    pointBorderWidth: 5,
                    pointHoverRadius: 5,
                    pointHoverBorderWidth: 5,
                    pointRadius: 5,
                    fill: false,
                    borderWidth: 3,
                    lineTension: 0,
                    data: [20, 80, 180, 140, 180, 120, 100,150,90,70,40,30]
                }]
            },
            options: {
                legend: {
                    position: "bottom",
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            fontColor: "rgba(255,255,255,1)",
                            fontStyle: "normal",
                            beginAtZero: true,
                            maxTicksLimit: 5,
                            padding: 10
                        },
                        gridLines: {
                            color: "rgba(210,217,224,0.5)",
                            zeroLineColor: "rgba(210,217,224,0.5)"
                        }

                    }],
                    xAxes: [{
                        gridLines: {
                            display: false
                        },
                        ticks: {
                            padding: 10,
                            fontColor: "rgba(255,255,255,1)",
                            fontStyle: "normal"
                        }
                    }]
                }
            }
        }); */
    }
}
</script>

<style>

</style>
